export const tr = {
    'click-value': 'CPC: {value}',
    holidays: 'Tatillerde',
    time: 'Saat',
    'time-correction': 'Saate göre teklif düzenleme',
    timezone: 'Saat dilimi',
    'with-working-weekends': 'Çalışılan tatil günlerini dikkate al'
};
